// extracted by mini-css-extract-plugin
module.exports = {"content":"content--LO5_wfE8","tagSettingsWrapper":"tagSettingsWrapper--q6Q7Qwvc"};